<template>
  <div class="payment-method-list-existing">
    <div class="payment-method-list-existing__current-method">
      <button
        v-if="paymentOnFileType === 'credit_card'"
        @click="handleExistingPayment(paymentOnFileType)"
        :class="[
          'payment-method-list-existing__item',
          !onFilePaymentMethodSelected && 'payment-method-list-existing__item-card--idle',
          onFilePaymentMethodSelected && 'payment-method-list-existing__item-card--selected',
          onFilePaymentMethodSelected && 'payment-method-list-existing__item--selected',
        ]"
      >
        <p class="payment-method-list-existing__item-onfile">ON FILE</p>
        <CreditCardDiscover class="payment-method-list-existing__item-discover" />
        <p class="payment-method-list-existing__item-ccnumber">
          **** **** **** ***{{ last4Digits }}
        </p>
        <p class="payment-method-list-existing__item-name">{{ username }}</p>
      </button>
      <button
        v-else
        @click="handleExistingPayment(paymentOnFileType)"
        :class="[
          'payment-method-list-existing__item payment-method-list-existing__item-card--paypal',
          onFilePaymentMethodSelected && 'payment-method-list-existing__item--selected',
        ]"
      >
        <PaypalLogoIcon class="payment-method-list-existing__item-icon" />
        <p class="payment-method-list-existing__item-onfile">ON FILE</p>
      </button>
      <!-- TODO: export this to a child/const component -->
      <div
        class="payment-method-list-existing__radio-button-wrapper"
        @click="handleExistingPayment(paymentOnFileType)"
      >
        <div class="payment-method-list-existing__radio-button-control-wrapper">
          <div
            :class="[
              'payment-method-list-existing__radio-button-control',
              onFilePaymentMethodSelected &&
                'payment-method-list-existing__radio-button-control--checked',
            ]"
          ></div>
          <span
            v-show="onFilePaymentMethodSelected"
            class="payment-method-list-existing__radio-button-control-check"
          ></span>
        </div>
        <div
          :class="[
            'payment-method-list-existing__radio-button-label',
            onFilePaymentMethodSelected &&
              'payment-method-list-existing__radio-button-label--selected',
          ]"
        >
          {{ radioButtonLabel }}
        </div>
      </div>
    </div>
    <div class="payment-method-list-existing__separator-wrapper">
      <p class="payment-method-list-existing__separator">OR</p>
    </div>
    <div class="payment-method-list-existing__add-method">
      <button
        @click="handleReplaceMethod()"
        :class="[
          'payment-method-list-existing__add',
          !onFilePaymentMethodSelected && 'payment-method-list-existing__add--selected',
        ]"
      >
        <PlusSymbolIcon class="payment-method-list-existing__add--icon" />
        <PlusSymbolIconBlack class="payment-method-list-existing__add--icon-hovered" />
        <p class="payment-method-list-existing__add--name">Replace payment method</p>
      </button>
      <!-- TODO: export this to a child/const component -->
      <div
        class="payment-method-list-existing__radio-button-wrapper"
        @click="handleReplaceMethod()"
      >
        <div class="payment-method-list-existing__radio-button-control-wrapper">
          <div
            :class="[
              'payment-method-list-existing__radio-button-control',
              !onFilePaymentMethodSelected &&
                'payment-method-list-existing__radio-button-control--checked',
            ]"
          ></div>
          <span
            v-show="!onFilePaymentMethodSelected"
            class="payment-method-list-existing__radio-button-control-check"
          ></span>
        </div>
        <div
          :class="[
            'payment-method-list-existing__radio-button-label',
            !onFilePaymentMethodSelected &&
              'payment-method-list-existing__radio-button-label--selected',
          ]"
        >
          Replace payment method
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PaypalLogoIcon from '@/assets/icons/paypal_white_logo.svg'
import PlusSymbolIcon from '@/assets/icons/plus_white.svg'
import PlusSymbolIconBlack from '@/assets/icons/plus_black.svg'
import CreditCardDiscover from '@/assets/icons/creditcard_discover.svg'

export default {
  name: 'PaymentMethodListExistingItem',
  components: {
    CreditCardDiscover: { ...CreditCardDiscover, name: 'CreditCardDiscover' },
    PaypalLogoIcon: { ...PaypalLogoIcon, name: 'PaypalLogoIcon' },
    PlusSymbolIcon: { ...PlusSymbolIcon, name: 'PlusSymbolIcon' },
    PlusSymbolIconBlack: {
      ...PlusSymbolIconBlack,
      name: 'PlusSymbolIconBlack',
    },
  },
  data() {
    return {
      // @ToDo: This can not be card as default if the user has paypal
      selectedMethod: '',
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      profile: state => state.auth.userProfile,
      selectedPaymentMethod: state => state.subscriptions.paymentMethod,
      paymentMethodOnFile: state => state.subscriptions.paymentMethodOnFile,
    }),
    last4Digits() {
      const { payment_method_mask } = this.paymentMethodOnFile
      return payment_method_mask || ''
    },
    paymentOnFileType() {
      const { payment_method_object } = this.paymentMethodOnFile
      return payment_method_object || 'credit_card'
    },
    username() {
      if (this.isAuthenticated) {
        const { first_name, last_name } = this.profile
        return `${first_name} ${last_name}`
      }
      return ''
    },
    onFilePaymentMethodSelected() {
      return this.selectedPaymentMethod !== ''
    },
    radioButtonLabel() {
      return this.paymentOnFileType === 'credit_card'
        ? `Pay with card ending in ${this.last4Digits}`
        : `Pay with Paypal`
    },
  },
  methods: {
    handleExistingPayment(paymentType) {
      const method = paymentType === 'credit_card' ? 'card' : 'paypal'
      this.selectedMethod = method
      this.$emit('existing-payment-clicked')
    },
    handleReplaceMethod() {
      this.selectedMethod = 'replace'
      this.$emit('replace-payment-clicked')
    },
  },
  mounted() {
    if (this.paymentOnFileType === 'credit_card') {
      this.selectedMethod = 'card'
    } else if (this.paymentOnFileType === 'paypal_billing_agreement') {
      this.selectedMethod = 'paypal'
    }
    this.$emit('existing-payment-clicked')
  },
}
</script>

<style lang="scss">
.payment-method-list-existing {
  display: flex;
  width: 100%;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  flex-flow: column;
  margin-bottom: 30px;
  @include desktop {
    margin-bottom: 0;
    flex-flow: row;
  }
  &__current-method {
    margin-bottom: 30px;
    @include desktop {
      margin-bottom: 0;
      flex-flow: row;
    }
  }
  &__item {
    position: relative;
    color: var(--gray-8);
    font-family: var(--font-regular);
    background: none;
    border: none;
    padding: 0;
    margin: 0 0 15px 0;
    cursor: pointer;
    width: 276px;
    height: 166px;
    margin-bottom: 15px;
    @include desktop {
      width: 100%;
    }
    &-discover {
      position: absolute;
      left: 45px;
      top: 55px;
      path {
        fill: var(--gray-8);
      }
      @include desktop {
        left: 20px;
      }
    }
    &-onfile {
      color: var(--white);
      position: absolute;
      top: 0;
      right: 20px;
      padding: 9px 14px;
      background: var(--purple-gradient);
      border-radius: 20px;
    }
    &-ccnumber {
      position: absolute;
      bottom: 45px;
      left: 45px;
      @include desktop {
        left: 20px;
      }
    }
    &-name {
      position: absolute;
      bottom: 0;
      left: 45px;
      @include desktop {
        left: 20px;
      }
    }
    &-card {
      $creditcard_on_file_bg: '../../../assets/icons/creditcard_on_file_bg.png';
      &--idle {
        background: var(--mid-gray-translucid);
        background: url(#{$creditcard_on_file_bg}), var(--mid-gray-translucid);
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
      }
      &--selected {
        background: var(--purple-gradient-vertical);
        background: url(#{$creditcard_on_file_bg}), var(--purple-gradient-vertical);
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
      }
      &--paypal {
        background: linear-gradient(90deg, #234c8d 0%, #1c91ce 100%);
        border-radius: 10px;
        min-width: 215px;
      }
    }
    &--selected {
      color: var(--white);
      .payment-method-list-existing__item-discover {
        path {
          fill: var(--white);
        }
      }
    }
    &:hover {
      box-shadow: 0px 4px 40px rgba(255, 255, 255, 0.4);
      border-radius: 10px;
    }
  }
  &__separator {
    &-wrapper {
      display: none;
      height: 170px;
      justify-content: center;
      align-items: center;
      position: relative;
      @include desktop {
        display: flex;
      }
      &::before {
        content: '';
        height: 170px;
        border: 1px solid #555555;
        position: absolute;
        top: -20px;
      }
    }
    background: #111111;
    border-radius: 20px;
    padding: 10px;
    font-size: 12px;
    line-height: 14px;
    color: var(--white);
    font-family: var(--font-regular);
    position: relative;
    top: -20px;
  }
  &__add {
    align-items: center;
    background: var(--mid-gray-translucid-gradient-three);
    border-radius: 10px;
    border: 1px solid var(--gray-3e);
    color: var(--deactivated-feature);
    cursor: pointer;
    font-family: var(--font-regular);
    font-size: rem(14);
    height: 166px;
    width: 276px;
    margin-bottom: 15px;
    padding: 5px 10px;
    display: flex;
    justify-content: center;
    flex-flow: column;
    @include tablet {
      width: 215px;
    }
    &:hover {
      background: var(--white);
      .payment-method-list-existing__add--icon {
        display: none;
      }
      .payment-method-list-existing__add--icon-hovered {
        display: block;
      }
      .payment-method-list-existing__add--name {
        color: var(--black);
      }
    }
    &--name {
      margin: 0;
      color: var(--light-blue-gray);
      width: 100%;
    }
    &--icon {
      fill: var(--white);
      height: 30px;
    }
    &--icon-hovered {
      display: none;
      height: 30px;
    }
    &--selected {
      background: #ffffff;
      border: 2px solid var(--light-blue-gray);
      box-shadow: 0px 4px 40px rgba(255, 255, 255, 0.4);
      border-radius: 10px;
      .payment-method-list-existing__add--name {
        color: var(--black);
      }
      .payment-method-list-existing__add--icon {
        display: none;
      }
      .payment-method-list-existing__add--icon-hovered {
        display: block;
      }
    }
  }
  &__radio-button {
    &-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    &-control {
      height: 20px;
      width: 20px;
      appearance: none;
      border: 1px solid var(--checkbox-border);
      border-radius: 100%;
      outline: none;
      transition-duration: 0.3s;
      cursor: pointer;
      &-wrapper {
        position: relative;
        display: flex;
        justify-content: flex-end;
      }
      &--checked {
        border-color: var(--green);
      }
      &-check {
        pointer-events: none;
        &:before {
          display: block;
          position: absolute;
          top: 5px;
          right: 5px;
          content: '';
          text-align: center;
          background-color: var(--white);
          border-radius: 100%;
          font-family: var(--font-bold);
          height: 10px;
          width: 10px;
        }
      }
    }
    &-label {
      margin-left: 10px;
      color: var(--gray-8);
      font-family: var(--font-regular);
      font-weight: 450;
      font-size: 14px;
      line-height: 20px;
      cursor: pointer;
      &--selected {
        color: var(--white);
      }
    }
  }
}
</style>
